import { uniqueArray } from '@nxtpeople/nxt-vue-library';

/**
 * Merges two objects deeply, including arrays of objects with unique IDs.
 * @param {any} target - The target object to merge into. This object will be modified.
 * @param {any} newDataObject - The newDataObject object to merge from. This object will overwrite the target object.
 * @returns {any} The merged object.
 */
export function deepMergeObject(baseObject: any, newDataObject: any) {
   const isObject = (obj: any) => obj && typeof obj === 'object';

   if (!isObject(baseObject) || !isObject(newDataObject)) {
      return newDataObject;
   }

   for (const key in newDataObject) {
      const baseObjectValue = baseObject[key];
      const newDataObjectValue = newDataObject[key];

      if (Array.isArray(baseObjectValue) && Array.isArray(newDataObjectValue)) {
         // check if the objects in the array have an id property

         if (baseObjectValue.length && newDataObjectValue.length && baseObjectValue[0].id !== undefined) {
            baseObject[key] = baseObject[key] = uniqueArray(
               [...baseObjectValue, ...newDataObjectValue].map((item, index, arr) => {
                  const existingItem = arr.find((i: any) => i.id === item.id);
                  return existingItem ? deepMergeObject(existingItem, item) : item;
               }),
               'id',
            );
         } else {
            // make a new array with unique values

            baseObject[key] = baseObjectValue.concat(newDataObjectValue).filter((item: any, index: number, arr: any) => {
               return arr.indexOf(item) === index;
            });
         }
      } else if (isObject(baseObjectValue) && isObject(newDataObjectValue)) {
         baseObject[key] = deepMergeObject({ ...baseObjectValue }, { ...newDataObjectValue });
      } else {
         baseObject[key] = baseObjectValue ? baseObjectValue : newDataObjectValue;
      }
   }

   return baseObject;
}
